<script setup lang="ts">
  import { provide, useTemplateRef } from 'vue'
  import TenantUserModalAdd from '../modals/TenantUserModalAdd.vue'
  import { tenantUsersModalsKey } from './tenant-users-modals'

  const addTenantUserModalRef = useTemplateRef('addTenantUserModalRef')

  const modals = {
    showAddTenantUser: () => {
      addTenantUserModalRef.value?.showModal()
    }
  }

  provide(tenantUsersModalsKey, modals)

  defineExpose(modals)
</script>
<template>
  <slot />
  <TenantUserModalAdd ref="addTenantUserModalRef" />
</template>
